let storage = global.sessionStorage

try {
  storage.setItem('test', 'test')
  storage.removeItem('test', 'test')
} catch (_error) {
  storage = {}
}

export default {
  getItem(key) {
    return storage[key]
  },
  setItem(key, value) {
    storage[key] = value
  },
  hasItem(key) {
    return key in storage
  },
  removeItem(key) {
    delete storage[key]
  },
  clear() {
    Object.keys(storage).forEach(key => this.removeItem(key))
  }
}
